import React from 'react';
import Axios from 'axios';
import ReactAnimatedWeather from 'react-animated-weather';

import Thunderstorm from "./img/Thunderstorm.jpg";
import Drizzle from "./img/Drizzle.jpg";
import Rain from "./img/Rain.jpg";
import Snow from "./img/Snow.jpg";
import Clear from "./img/Sunny.jpg";
import Clouds from "./img/Cloudy.jpg";
import Mist from "./img/Mist-14.jpg";
import Smoke from "./img/Smoke.jpg";
import Haze from "./img/Haze.jpg";
import Dust from "./img/Dust.jpg";
import Fog from "./img/Fog.jpg";
import Sand from "./img/Sand.jpg";
import Ash from "./img/Ash.jpg";
import Squall from "./img/Squall.jpg";
import Tornado from "./img/Tornado.jpg";

class WeatherComponent extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      data: [],
      city: '',
      bgImg: "Clouds",
      currentDate: '',
      loading: true
    };
    this.apikey = "5e616103fbea9685cf35eca54bb8bff4"; // Replace with your API key
  }

  componentDidMount() {
    this.fetchWeatherAndTime();
    this.intervalId = setInterval(() => {
      const now = new Date();
      this.setState({ currentDate: now.toLocaleTimeString() });
    }, 1000);
  }

  componentWillUnmount() {
    clearInterval(this.intervalId);
  }

  fetchWeatherAndTime = async () => {
    try {
      const { weatherCity, weatherCountry } = this.props;
      if (weatherCity && weatherCountry) {
        this.setState({ city: weatherCity });
        const weatherData = await this.fetchWeatherData(weatherCity, weatherCountry);
        if (weatherData) {
          this.setState({
            data: weatherData,
            bgImg: weatherData[0].weather[0].main
          });
        } else {
          console.error('Failed to fetch weather data.');
        }
      } else {
        const userLocation = await this.getUserLocation();
        if (userLocation) {
          const userCity = await this.getCityFromCoordinates(userLocation);
          if (userCity) {
            this.setState({ city: userCity });
            const weatherData = await this.fetchWeatherData(userCity);
            if (weatherData) {
              this.setState({
                data: weatherData,
                bgImg: weatherData[0].weather[0].main
              });
            } else {
              console.error('Failed to fetch weather data.');
            }
          }
        }
      }
      this.setState({ loading: false });
    } catch (error) {
      console.error('Error fetching weather data:', error);
      this.setState({ loading: false });
    }
  }

  getUserLocation = () => {
    return new Promise((resolve, reject) => {
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(
          (position) => {
            const { latitude, longitude } = position.coords;
            resolve({ latitude, longitude });
          },
          (error) => {
            console.error("Error getting user location:", error);
            reject(error);
          }
        );
      } else {
        console.error("Geolocation is not supported by this browser.");
        reject("Geolocation is not supported by this browser.");
      }
    });
  }

  getCityFromCoordinates = async ({ latitude, longitude }) => {
    try {
      const response = await fetch(`https://api.bigdatacloud.net/data/reverse-geocode-client?latitude=${latitude}&longitude=${longitude}&localityLanguage=en`);
      const data = await response.json();
      if (data.localityInfo && data.localityInfo.administrative) {
        return data.city;
      }
    } catch (error) {
      console.error('Error fetching city from coordinates:', error);
    }
    return null;
  }

  fetchWeatherData = async (city, weatherCountry = '') => {
    try {
      const weatherResponse = await Axios.get(`https://api.openweathermap.org/data/2.5/forecast?q=${city},${weatherCountry}&appid=${this.apikey}`);
      const forecastData = weatherResponse.data.list;

      // Filter out the forecast for the next 14 days
      const next14DaysForecast = {};
      forecastData.forEach(forecast => {
        const forecastTimestamp = new Date(forecast.dt * 1000).toISOString().slice(0, 10);
        if (!next14DaysForecast[forecastTimestamp]) {
          next14DaysForecast[forecastTimestamp] = forecast;
        }
      });

      return Object.values(next14DaysForecast);
    } catch (error) {
      console.error('Error fetching weather data:', error);
      return null;
    }
  }

  setIcon = (value) => {
    const iconMap = {
      "Thunderstorm": <div className='RAIN'> <ReactAnimatedWeather icon="RAIN" color="white" size={64} animate={true} /></div>,
      "Drizzle": <div className='SLEET'> <ReactAnimatedWeather icon="SLEET" color="white" size={64} animate={true} /></div>,
      "Rain": <div className='RAIN'> <ReactAnimatedWeather icon="RAIN" color="white" size={64} animate={true} /></div>,
      "Snow": <div className='SNOW'> <ReactAnimatedWeather icon="SNOW" color="white" size={64} animate={true} /></div>,
      "Clear": <div className='CLEAR_DAY'> <ReactAnimatedWeather icon="CLEAR_DAY" color="white" size={64} animate={true} /></div>,
      "Clouds": <div className='CLOUDY'> <ReactAnimatedWeather icon="CLOUDY" color="white" size={64} animate={true} /></div>,
      "Mist": <div className='FOG'> <ReactAnimatedWeather icon="FOG" color="white" size={64} animate={true} /></div>,
      "Smoke": <div className='FOG'> <ReactAnimatedWeather icon="FOG" color="white" size={64} animate={true} /></div>,
      "Dust": <div className='FOG'> <ReactAnimatedWeather icon="FOG" color="white" size={64} animate={true} /></div>,
      "Fog": <div className='FOG'> <ReactAnimatedWeather icon="FOG" color="white" size={64} animate={true} /></div>,
      "Sand": <div className='WIND'> <ReactAnimatedWeather icon="WIND" color="white" size={64} animate={true} /></div>,
      "Ash": <div className='FOG'> <ReactAnimatedWeather icon="FOG" color="white" size={64} animate={true} /></div>,
      "Squall": <div className='WIND'> <ReactAnimatedWeather icon="WIND" color="white" size={64} animate={true} /></div>,
      "Tornado": <div className='WIND'> <ReactAnimatedWeather icon="WIND" color="white" size={64} animate={true} /></div>,
    };
    return iconMap[value] || null;
  }

  formatDate = (date) => {
    const weekdayOptions = { weekday: 'long' };
    const dayOptions = { day: '2-digit' };
    const monthOptions = { month: 'short' };

    const weekday = date.toLocaleDateString('en-US', weekdayOptions);
    const day = date.toLocaleDateString('en-US', dayOptions);
    const month = date.toLocaleDateString('en-US', monthOptions);

    return `${weekday}, ${day} ${month}`;
  }

  convertTemp = (temp) => {
    const { tempType } = this.props;
    if (tempType === 'F') {
      return ((temp - 273.15) * 9 / 5 + 32).toFixed(0) + " °F"; // Convert to Fahrenheit
    } else {
      return (temp - 273.15).toFixed(0) + " °C"; // Keep Celsius
    }
  }

  render() {
    const { initialDay } = this.props;
    const { loading, bgImg, currentDate, city, data } = this.state;

    if (loading) {
      return <div>Loading...</div>;
    }

    return (
      <div className='weather text-light' style={{ backgroundImage: `linear-gradient(rgba(0,0,0,0.2), rgba(0,0,0,0.2)), url(${bgImg === "Rain" ? Rain : bgImg === "Thunderstorm" ? Thunderstorm : bgImg === "Drizzle" ? Drizzle : bgImg === "Snow" ? Snow : bgImg === "Clear" ? Clear : bgImg === "Clouds" ? Clouds : bgImg === "Mist" ? Mist : bgImg === "Smoke" ? Smoke : bgImg === "Haze" ? Haze : bgImg === "Dust" ? Dust : bgImg === "Fog" ? Fog : bgImg === "Sand" ? Sand : bgImg === "Ash" ? Ash : bgImg === "Squall" ? Squall : bgImg === "Tornado" ? Tornado : Thunderstorm})` }}>
        {initialDay !== "single_day" ? (
          <>
            <div className='selected-day d-flex justify-content-between md:align-items-end'>
              <div className='time d-flex flex-column justify-content-start text-light '>
                <div>
                  <h1>{currentDate}</h1>
                  <p>{this.formatDate(new Date())}</p>
                  <hr className='h-2 w-100 bg-light' />
                  <h1>{city}</h1>
                  <p>{city}</p>
                </div>
              </div>
              <div className='report d-flex text-light'>
                <div className='main-card'>
                  <div className='moonrain'>
                    {data[0] && data[0].weather[0] && this.setIcon(data[0].weather[0].main)}
                  </div>
                  <div className='d-flex flex-column'>
                    <h1>{this.convertTemp(data[0] && data[0].main && data[0].main.temp)}</h1>
                    <h2>{data[0] && data[0].weather[0] && data[0].weather[0].description}</h2>
                    <div className='d-flex'>
                      <div className='d-flex flex-column mr-3'>
                        <p>Wind</p>
                        <p>{data[0] && data[0].wind && data[0].wind.speed}km/h</p>
                      </div>
                      <div className='d-flex flex-column mr-3'>
                        <p>Precipitation</p>
                        <p>{data[0] && data[0].pop}%</p>
                      </div>
                      <div className='d-flex flex-column mr-3'>
                        <p>Humidity</p>
                        <p>{data[0] && data[0].main && data[0].main.humidity}%</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className='daysList'>
              <div className='daysList-div d-flex justify-content-around items'>
                {data.map((day, index) => {
                  if (index === 0) { return null; }
                  return (
                    <button
                      key={index}
                      className='daysList-div-card d-flex flex-column bg-transparent text-white'
                      onClick={() => this.setState({ bgImg: day.weather[0].main })}
                    >
                      <p style={{ height: "10%" }}>{this.formatDate(new Date(day.dt * 1000))}</p>
                      <div className='d-flex m-auto mt-3 pt-3'>
                        {this.setIcon(day.weather[0].main)}
                        <p className='mobile-hide'>{(day.main.temp - 273.15).toFixed(0)} °F</p>
                      </div>
                      <p className='custom-hide m-auto'>{this.convertTemp(data[0] && data[0].main && data[0].main.temp)} {day.weather[0].description}</p>
                      <hr className='custom-hide' style={{ width: "100%", height: "2px", background: "white", margin: "5px 0px" }} />
                      <div className='md:d-flex flex-column mx-auto font-italic custom-hide '>
                        <p>Wind {day.wind.speed}km/h</p>
                        <p>Humidity {day.main.humidity}%</p>
                        <p>Precipitation {data[0] && data[0].pop}%</p>
                      </div>
                    </button>
                  );
                })}
              </div>
            </div>
          </>
        ) : (
          <div className='one-day-card d-flex w-full justify-content-center align-items-center flex-wrap'>
            <div className='d-flex flex-column justify-content-start text-light p-5'>
              <h1>{currentDate}</h1>
              <p>{this.formatDate(new Date())}</p>
              <hr className='h-2 w-100 bg-light' />
              <h1>{city}</h1>
              <p>{city}</p>
            </div>
            <div className='d-flex text-light flex-wrap justify-content-center'>
              <div className=''>
                <div className='moonrain'>
                  {this.setIcon(data[0] && data[0].weather[0] && data[0].weather[0].main)}
                </div>
                <div className='d-flex flex-column'>
                  <h1>{this.convertTemp(data[0] && data[0].main && data[0].main.temp)}</h1>
                  <h2>{data[0] && data[0].weather[0] && data[0].weather[0].description}</h2>
                  <div className='d-flex flex-wrap'>
                    <div className='d-flex flex-column mr-3'>
                      <p>Wind</p>
                      <p>{data[0] && data[0].wind && data[0].wind.speed}km/h</p>
                    </div>
                    <div className='d-flex flex-column mr-3'>
                      <p>Precipitation</p>
                      <p>{data[0] && data[0].pop}%</p>
                    </div>
                    <div className='d-flex flex-column mr-3'>
                      <p>Humidity</p>
                      <p>{data[0] && data[0].main && data[0].main.humidity}%</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    );
  }
}

export default WeatherComponent;
